/**
 * Theme JS building
 */
import '@babel/polyfill';
import './modernizr';
import './dragdealer';
import 'lightgallery';
import 'list.js';
import Theme from './theme';

// Export the theme controller for global usage.
window.Theme = Theme;

// Require main style file here for concatenation.
import '../styles/main.scss';
